<template>
  <div ref="info" class="profile-info">
    <div class="container inner-container">
      <div class="row">
        <div class="col-6">
          <h1 class="welcome-msg">
          {{ cpLang('profile.welcome', {username}) }}
          </h1>
        </div>
        <div class="col-4 notification">
          <!-- <h4>(<i class="fas fa-bell"/>) You have 5 unread messages</h4> -->
        </div>
        <div class="col-2 logout-btn">
          <a @click="$auth.logout()" class="btn">{{ cpLang('menu.logout') }}</a>
        </div>
      </div>
      <div class="clear-both">
        <small class="last-update">{{ cpLang('profile.lastupdate') }} {{ $auth.user.statistics.lastupdate }}</small>
        <div class="col-5">
          <ProfilePic />
          <div class="col-summary">
            <ProfileSummary :is-nav-bar="isNavBar" class="mb-lg-4" />
            <div class="strength-wrap">
              <ProfileStrength :is-nav-bar="isNavBar" />
              <router-link v-if="completeness < 100" @click.native="closePanel" class="profile-btn mt-2" to="/myprofile">
                {{ cpLang('profile.viewfull') }}
              </router-link>
            </div>
          </div>
        </div>
        <div class="col-7 pb-3">
          <JobNumber is-search-nav />
          <!-- <div class="resume-info">
            <div v-if="resume !== null" class="resume-wrap">
              <i class="far fa-file"><span>{{ resume.filetype }}</span></i>
              <div>
                <b class="font-title grey">{{ cpLang('profile.your_default_cv') }}: </b>
                {{ resume.resumename }}
                <p class="font-title pt-2">
                  <router-link to="/myprofile#cv">
                    {{ cpLang('profile.manage_cv') }}
                  </router-link>
                  </p>
              </div>
            </div>
            <div v-else>
              <i class="far fa-file"><span><b>?</b></span></i>
              <router-link to="/myprofile#cv">
                {{ cpLang('profile.upload_your_cv') }}
              </router-link>
            </div>
          </div> -->
        </div>
      </div>
      <div class="clear-both">
        &nbsp;
      </div>
    </div>
  </div>
</template>
<script>
import ProfilePic from '@/components/profile/ProfilePic'
import ProfileStrength from '@/components/profile/ProfileStrength'
import ProfileSummary from '@/components/profile/ProfileSummary'
import JobNumber from '@/components/profile/JobNumber'
// import commonFunc from '~/assets/js/commonHelper.js'
export default {
  components: {
    JobNumber,
    ProfilePic,
    ProfileStrength,
    ProfileSummary
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    isNavBar: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      completeness: 0,
      resume: null
    }
  },
  computed: {
    username: function () {
      if (this.$auth.loggedIn) {
        return decodeURIComponent(this.$auth.user.firstname ? this.$auth.user.firstname : this.$auth.user.email).replace(/\+/gm, ' ')
      }
      return ''
    }
  },
  created() {
    const res = this.$auth.user.statistics
    this.completeness = res.completeness
    this.resume = res.resume
  },
  methods: {
    closePanel: function() {
      const event = new Event('mClosepanel')
      window.dispatchEvent(event)
    }
  }
}
</script>
<style lang='scss'>
#settingSvg{
  // position: absolute;
  // right: 9%;
  // top: 17%;
  z-index: 999;
  svg{
    // margin-bottom: 8px;
  }
}
.show-on-m{
  display: none;
}
b.strength{
  color:#EE8387 !important;
}
.resume-info{
  text-align: center;
  font-size: 14px;
  padding-top:35px;
  .resume-wrap{
    display: flex;
    justify-content: center;
    align-items: flex-end;
    i{
      font-size: 50px;
      position: relative;
      color: #CCCCCC;
      vertical-align: text-bottom;
      margin-bottom: -12px;
      margin-right: 5px;
      span{
        font-size: 10px;
        position: absolute;
        left: 4px;
        top: 21px;
        width: 30px;
        text-align: center;
        b{
          font-size: 18px;
        }
      }
    }
  }
}
.logout-btn{
  text-align:right;
  a{
    color:#2B59C3;
    font-size:14px;
  }
}
.completion-wrap{
  padding-bottom: 0px;
}
.welcome-msg{
  color:#2B59C3;
  font-size:36px;
    padding-left: 155px;
  font-weight: 500;
}
.progress{
  background: transparent linear-gradient(90deg, #FA8383 0%, #00CDA7 100%) 0% 0% no-repeat padding-box;
  border-radius: 13px;
  height:15px;
}
.profile-btn{
    font-size:14px;
    color: #fff;
    background: linear-gradient(217deg, #00CDA7, #0081BE) !important;
    padding: 10px 30px;
    display: inline-block;
    border-radius: 100px;
    &:hover{
      color:#fff;
    }
}
.profile-info{
  width: 100%;
  // background: #ffffff;
  margin-top: 35px;
  transition: all 0.2s ease-out;
  cursor: default;
  z-index: 3;
  opacity: 1;
  &.open{
    opacity: 1;
  }
  .container{
    position: relative;
    >.row{
      padding:0px 25px 7px 25px;
    }
    .last-update{
      position: absolute;
      top: 3%;
      right: 12%;
      font-size: 10px;
    }
  }
  .col-2,.col-1{
      z-index:999;
  }
  .notification{
    padding-top: 42px;
    text-align: left;
    h4{
      font-size: 16px;
    }
  }
  .btn-primary{
    width: 100%;
    background: transparent;
    color:#2B59C3!important;
    border:0;
    text-align: right;
  }
  .col-summary{
    padding: 0px 10px 40px 170px;
    .profile-summary{
      min-height: 100px;
    }
    .completion{
      max-width: 300px;
      margin: 10px 0px;
      p{
        text-align: left;
      }
      .desc{
        display: none;
      }
    }
  }
}
</style>
